import { render, staticRenderFns } from "./ComplaintStatus.vue?vue&type=template&id=b6d74bca&scoped=true&"
import script from "./ComplaintStatus.vue?vue&type=script&lang=js&"
export * from "./ComplaintStatus.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintStatus.vue?vue&type=style&index=0&id=b6d74bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d74bca",
  null
  
)

export default component.exports